module.exports = __webpack_public_path__ + "static/media/win_coins_0e2c37_150.bf3264d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/win_coins_0e2c37_150.png
// module id = 606
// module chunks = 0